module.exports = __webpack_public_path__ + "img/playgol.c76d790d.svg";